export const Signout = () => {
  localStorage.removeItem('logged');
  localStorage.removeItem('accessToken');
  window.location.replace('/login-bs-as');
};
